export default __webpack_public_path__ + "static/media/partner18.abec1985.webp";